import { Component, OnInit } from '@angular/core';
import {SalesMessageConfig, SalesMessagesSectionConfig} from './sales-messages-section.config';
import {InternalConfigService} from '../../../services/internal-config.service';

@Component({
  selector: 'app-sales-messages-section',
  templateUrl: './sales-messages-section.component.html',
  styleUrls: ['./sales-messages-section.component.scss']
})
export class SalesMessagesSectionComponent implements OnInit {

  sectionVisible: boolean;
  messagesConfig: SalesMessageConfig[];

  constructor(private internalConfigService: InternalConfigService) { }

  ngOnInit() {
    this.initSectionVisible();
    this.createConfig();
  }

  private createConfig(): void {
    const config = new SalesMessagesSectionConfig();
    this.messagesConfig = config.createConfig();
  }

  private initSectionVisible(): void {
    this.sectionVisible = this.internalConfigService.resolveSectionVisibility('salesMessagesSection');
  }

}
